module.exports = __webpack_public_path__ + "check-developer@3x.4f6fcad52dde294f3ab1e4ce4da5bcf0.png";